export default "/credits/business/assets/ee04af03e57b86705e80331f7eceb7e7.png";